import type { ReactNode } from 'react';
import type { FieldError } from 'react-hook-form';
import { Label } from '../../components/ui/label';
import { cn } from '../utils';
import { FormMessage } from './FormMessage';

export interface FormFieldProps {
  id: string;
  label?: string;
  error: FieldError | undefined;
  helperText?: string;
  className?: string;
  children: ReactNode;
}

export function FormField({ id, label, error, helperText, className, children }: FormFieldProps) {
  return (
    <div className={cn('flex flex-col gap-2', className)}>
      {label ? (
        <Label htmlFor={id} id={`${id}-label`}>
          {label}
        </Label>
      ) : null}
      <div className="flex flex-col gap-1">
        {children}
        <FormMessage id={id} error={error} helperText={helperText} />
      </div>
    </div>
  );
}
